import { toBlob } from 'dom-to-image-more';

export default  {
  methods: {
    async generateBlobImage(html) {
      return await toBlob(html, {
        pixelRatio: 2,
        backgroundColor: 'white'
      });
    },
    async generateBase64Image(html) {
      const blob = await this.generateBlobImage(html);
      return await this.blobToBase64(blob);
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          resolve(reader.result); // This will be the base64 string (Data URL)
        };

        reader.onerror = reject;

        reader.readAsDataURL(blob); // This triggers the conversion
      });
    }
  }
}
